// import { URL, Roles, USER } from '../../constants/insurance/constant';
// import { axiosFinal, _axios } from '../../plugins/axios';
// import ClevertapReact from 'clevertap-react';
// import moment from 'moment';
// import * as XLSX from "xlsx";

import { URL } from "../../constants/insurance/constant";
import { axiosFinal, _axios } from "../../plugins/axios";


export const getContracts = () => {
    let contracts = null;
    if (localStorage.getItem('user_details') && JSON.parse(localStorage.getItem('user_details')) && localStorage.getItem('children') && JSON.parse(localStorage.getItem('children')) && localStorage.getItem('mb_contracts') && JSON.parse(localStorage.getItem('mb_contracts'))) {
        let children = JSON.parse(localStorage.getItem('children'))
        let mb_contracts = JSON.parse(localStorage.getItem('mb_contracts'))
        let result = mb_contracts?.length && mb_contracts.filter(elem1 => children.some(function (elem2) {
            if (parseInt(elem1.id) === parseInt(elem2.erTypeId)) {
                elem1['er_Id'] = elem2.id;
                return elem2
            }
        }
        ));
        return result;
    }
    else {
        return []
    }
    return contracts
    // filter(contracts)
}

export const uploadExcelOrders = (data) => {

    const config = {
        method: "post",
        url: URL.providercore_url + "insurance/uploadExcelOrders",
        // url: "https://ch-api-procheck.medibuddy.in/UploadExcelOrders",
        headers: {
            accesstoken: JSON.parse(localStorage.getItem("access_token")),
        },
        data: data
    }
    return axiosFinal(config)
        .then((response) => {
            console.log(response)
            return response.data;
        })
        .catch((error) => {
            if (error.response) {
                let errorObj = {
                    errorStatus: error.response.status,
                    errorResponse: error.response
                }
                return errorObj
            }
        });
}

export const getCorporate = () => {
    let children = JSON.parse(localStorage.getItem("children"));
    let userAssignedRole = JSON.parse(localStorage.getItem("user_details")).properties["Assigned Contracts"];
    for (const key in children) {
        if(children[key].erTypeId == userAssignedRole){
            console.log(children[key])
            return children[key]
        }
    }
}

export const getPackageEntityRelationList = (data) => {
    let config = {
        method: "post",
        headers:{
            contentType : 'application/json',
            accesstoken: JSON.parse(localStorage.getItem("access_token"))
        },
        url: URL.providercore_url + "insurance/packageEntityRelationList",
        data: data
    }
    return _axios(config)
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err;
        })
}

export const getEntityListForContract = (contractId) => {
    const entityList = JSON.parse(localStorage.getItem('children'));
    if (entityList) {
        return entityList.filter(child => child.erTypeId == contractId);
    }
    return [];
}
